import React from "react";
import Input from "@components/forms/Input";

const ForgotPasswordForm = ({ t, setStep,handleInputChange,forgotData,handleForgotPassword, loading }) => {
 
 const isFormValid = forgotData.email;
  return (
    <>
       <div className="mb-4">
               <Input
                 value={forgotData.email}
                 handleChange={handleInputChange("email")}
                 placeholder={t("email")}
                 type="email"
               />
             </div>
       <div className="d-grid mb-4">
        <button
          type="button"
          className={`btn p-3  ${isFormValid ? "btn-primary" : "btn-outline-secondary"}`}
          onClick={() => handleForgotPassword()}
          disabled={!isFormValid || loading}
        >
          {loading ? t("loading") : t("to_log_in")}
        </button>
      </div>
       <div className="d-flex justify-content-between my-3">
            <button
              type="button"
              className="btn btn-link text-primary text-decoration-none p-0"
              onClick={() => setStep('login')}
            >
              {t('back_to_login')}
            </button>
          </div>
    </>
  );
};

export default ForgotPasswordForm;
